(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ops-before-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', function (e) {
  var r = e.target.closest && e.target.closest('.ops-ba__range'); if (!r) return;
  var box = r.closest('[data-ba]'); box.style.setProperty('--pos', r.value + '%');
  r.setAttribute('aria-valuetext', 'Widoczne ' + r.value + '% zdjęcia przed');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ops-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var f = e.target.closest('.ops-vc__facade');
  if (f) {
    var i = document.createElement('iframe');
    i.src = f.dataset.embed + (f.dataset.embed.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    i.title = f.dataset.title || 'Wideo'; i.allow = 'autoplay; encrypted-media; picture-in-picture'; i.allowFullscreen = true;
    f.replaceWith(i); i.focus(); return;
  }
  var n = e.target.closest('[data-vc-dir]');
  if (n) {
    var t = n.closest('[data-vc]').querySelector('.ops-vc__track');
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollBy({ left: Number(n.dataset.vcDir) * t.clientWidth * 0.8, behavior: rm ? 'auto' : 'smooth' });
  }
});

  } catch(e) { console.error(e); }
})();
})();
